import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { filter, from, reduce } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class QueryParamService {
  constructor(private route: ActivatedRoute, private router: Router) {}

  getQueryParam(key?: string): any {
    const queryParams = this.route.snapshot.queryParams;
    return key ? queryParams[key] ?? null : queryParams;
  }

  setQueryParams(params: any) {
    const currentParams = { ...this.route.snapshot.queryParams, ...params };

    from(Object.entries(currentParams)) // Convert object to key-value pairs
      .pipe(
        filter(([_, value]) => value !== null && value !== undefined && value !== ''), // Remove empty values
        reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {}) // Rebuild the object
      )
      .subscribe(filteredParams => {
        this.router.navigate([], {
          queryParams: filteredParams, // Pass the updated params
          replaceUrl: true // Prevents adding new history entry
        });
      });
  }

  removeQueryParam(key: string) {
    const queryParams = { ...this.route.snapshot.queryParams };
    if (queryParams.hasOwnProperty(key)) {
      delete queryParams[key];
      this.router.navigate([], { queryParams, replaceUrl: true });
    }
  }
}
